// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3JK9B","imageUploader":"EGiftCard_imageUploader__3VQOc"};